<template>
  <div class="flex column gaps">
    <div class="box grow border b-rad-5 card-shadow--large mh-15" style="max-width: 700px;">
      <FullCalendar
        ref="fullCalendar"
        class="calendar-wrap"
        :options='calendarOptions'></FullCalendar>
    </div>
    <div class="mh-15 flex column gaps">
      <div class="legend flex gaps">
        <div class="square sess sess-0"></div>
        <div class="box left center">More than 75% of spaces left</div>
      </div>
      <div class="legend flex gaps">
        <div class="square sess sess-1"></div>
        <div class="box left center">50% - 75% of spaces left</div>
      </div>
      <div class="legend flex gaps">
        <div class="square sess sess-2"></div>
        <div class="box left center">25% - 50% of spaces left</div>
      </div>
      <div class="legend flex gaps">
        <div class="square sess sess-3"></div>
        <div class="box left center">Less than 25% of spaces left</div>
      </div>
      <div class="legend flex gaps">
        <div class="square sess sess-4"></div>
        <div class="box left center">No spaces left</div>
      </div>
      <div class="legend flex gaps">
        <div class="square sess sess-5"></div>
        <div class="box left center">Not available for booking</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  name: 'Calendar',

  props: {
    basket: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data () {
    return {
      // testArray: [1, 2],
      calendarOptions: {
        plugins: [ dayGridPlugin, interactionPlugin ],
        initialView: 'dayGridMonth',
        initialDate: new Date().toISOString().slice(0, 10),
        headerToolbar: {
          start: '', // will normally be on the left. if RTL, will be on the right
          center: 'title',
          end: '' // will normally be on the right. if RTL, will be on the left
        },
        dateAlignment: 'week',
        height: 'auto',
        dateClick: this.dayClick,
        editable: true,
        events: []
      }
    }
  },

  components: {
    FullCalendar
  },

  computed: {
    ...mapGetters([
      'calendarDaysArray',
      'calendarEventsArray'
    ]),
    today () {
      return new Date().getTime()
    }
  },

  methods: {
    ...mapActions(['selectDay']),
    dayClick (arg) {
      if (new Date(arg.date).getTime() > this.today - 86400000) {
        if (new Date(arg.date).getTime() > this.today + (86400000 * 30)) {
          this.$message({
            showClose: true,
            message: 'Sorry, we can\'t confrim bookings more then 30 days in advance. Please select another date',
            type: 'error'
          })
        } else {
          if (this.calendarDaysArray.includes(arg.dateStr)) {
            this.calendarOptions.events = [{ start: arg.dateStr, classNames: ['selected'], display: 'background' }]
            this.selectDay({ day: arg.dateStr, isSame: this.basket.day === arg.dateStr })
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
            this.$emit('setDay', days[new Date(arg.date).getDay()])
          } else {
            this.$message({
              showClose: true,
              message: 'Our rink timing is not arranged for the day selected. Please check later.',
              type: 'error'
            })
          }
        }
      } else {
        this.$message({
          showClose: true,
          message: 'Ouch, we don\'t have time machine, sorry. This day already passed.',
          type: 'error'
        })
      }
    }
  },
  activated () {
    let calendarApi = this.$refs.fullCalendar.getApi()
    calendarApi.updateSize()
    this.calendarOptions.events = this.calendarEventsArray
  }
}
</script>
